// =====================================================
// 📁 POSCreditNoteProductsPanel.tsx
// =====================================================

import { useState } from 'react';

import { useCreditNoteSaleLookup } from '../../../../../hooks/sale/useCreditNoteSaleLookup';

import { useCreditNoteSale } from '../../../../../hooks/sale/useCreditNoteSale';

import { useSale } from '../../../../../hooks/sale/useSale';

import POSCreditNoteToolbar from './POSCreditNoteToolbar';

import POSCreditNoteProductTable from '../table/POSCreditNoteProductTable';

import POSCreditNoteProductGrid from '../table/POSCreditNoteProductGrid';

import POSProductViewToggle from '../../products/POSProductViewToggle';

const POSCreditNoteProductsPanel = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { selectedSaleDetail } = useCreditNoteSaleLookup();

  const { handlerClearAllProducts, handlerReturnAllProducts } =
    useCreditNoteSale();

  const { form } = useSale();

  // =====================================================
  // 🔹 States
  // =====================================================
  const [viewMode, setViewMode] = useState<'list' | 'cards'>('list');

  const [query, setQuery] = useState('');

  // =====================================================
  // 🔹 Handlers
  // =====================================================
  const handleClearAll = () => {
    if (!form?.id) return;

    handlerClearAllProducts(form.id);
  };

  const handleReturnAll = () => {
    if (!form?.id) return;

    handlerReturnAllProducts(form.id);
  };

  // =====================================================
  // 🔹 Flags
  // =====================================================
  const disabled = !selectedSaleDetail;

  // =====================================================
  // 🎨 Empty State
  // =====================================================
  if (!selectedSaleDetail) {
    return (
      <div
        className="
          flex
          min-h-[250px]
          items-center
          justify-center

          rounded-2xl
          border
          border-dashed
          border-slate-300

          bg-slate-50

          text-center

          dark:border-strokedark
          dark:bg-boxdark
        "
      >
        <div>
          <p
            className="
              text-sm
              font-medium
              text-slate-600

              dark:text-slate-300
            "
          >
            Debes seleccionar una venta
          </p>

          <p
            className="
              mt-1
              text-xs
              text-slate-500
            "
          >
            para acreditar productos en la nota de crédito.
          </p>
        </div>
      </div>
    );
  }

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div className="flex flex-col gap-4">
      {/* ===================================================== */}
      {/* 🔹 Toolbar */}
      {/* ===================================================== */}
      <div
        className="
          flex
          flex-col
          gap-3

          lg:flex-row
          lg:items-center
          lg:justify-between
        "
      >
        {/* 🔹 Left */}
        <div className="flex-1">
          <POSCreditNoteToolbar
            query={query}
            disabled={disabled}
            onSearch={setQuery}
            onClearAll={handleClearAll}
            onReturnAll={handleReturnAll}
          />
        </div>

        {/* 🔹 Right */}
        <POSProductViewToggle viewMode={viewMode} onChange={setViewMode} />
      </div>

      {/* ===================================================== */}
      {/* 🔹 Products */}
      {/* ===================================================== */}
      {viewMode === 'list' ? (
        <POSCreditNoteProductTable query={query} />
      ) : (
        <POSCreditNoteProductGrid query={query} />
      )}
    </div>
  );
};

export default POSCreditNoteProductsPanel;
